module.exports = __webpack_public_path__ + "static/media/tgle-alma-dark.ec8ce0cc.png";